module.exports = __webpack_public_path__ + "img/sort-down.62824be3.svg";